import assetPath from '/app/packages/lebenslauf/articles/src/assets/der-ultimative-leitfaden-fuer-deine-online-bewerbung-1.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')